import { customMedia } from '@space-core/styles'
import { ShowcaseOrientation } from '@space-shell/common/services/membership'
import styled from 'styled-components'

import LoaderList from './loaderList'

const Wrapper = styled.div`
  display: grid;
  row-gap: calc(var(--spacer-8) * 2);
  margin-bottom: calc(var(--spacer-10) * 2);

  ${customMedia.greaterThan('md')`
    row-gap: var(--spacer-8);
    margin-bottom: var(--spacer-8);

  `}
`

const ShowcaseLoader = () => {
  return (
    <Wrapper data-test='showcase-loader'>
      <LoaderList orientation={ShowcaseOrientation.VERTICAL} title />
      <LoaderList orientation={ShowcaseOrientation.HORIZONTAL} title />
      <LoaderList orientation={ShowcaseOrientation.HORIZONTAL} title />
    </Wrapper>
  )
}

export default ShowcaseLoader
